export enum TABS {
	CARD,
	ACCOUNT,
	BUDGET,
}
